import { render, staticRenderFns } from "./PageConfirmBasket.vue?vue&type=template&id=35db4dab&scoped=true&"
import script from "./PageConfirmBasket.vue?vue&type=script&lang=js&"
export * from "./PageConfirmBasket.vue?vue&type=script&lang=js&"
import style0 from "./PageConfirmBasket.vue?vue&type=style&index=0&id=35db4dab&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35db4dab",
  null
  
)

export default component.exports